import 'izitoast/dist/css/iziToast.min.css';
import iZtoast from 'izitoast';

const toast = {
    error: (message, title = 'Error') => {
        return iZtoast.error({
            title: title,
            message: message,
            position: 'bottomCenter'
        });
    },
    success: (message, title = 'Success') => {
        return iZtoast.success({
            title: title,
            message: message,
            position: 'bottomCenter'
        });
    },
    warning: (message, title = 'Warning') => {
        return iZtoast.warning({
            title: title,
            message:message,
        });
    },
    info: (message, title = 'Info') => {
        return iZtoast.info({
            title: title,
            message:message,
        });
    }
};

export default toast;


// WEBPACK FOOTER //
// ./src/core/toast.js